module.exports = __webpack_public_path__ + "static/media/PA-Icon-Fahrrad-neg_1.9997a7c7.svg";